import AgencySaleAddOrderScreen from 'features/Agency/screens/AgencySaleAddOrderScreen';
import AgencySaleDetailScreen from 'features/Agency/screens/AgencySaleDetailScreen';
import DealerReconciliationReportDetailScreen from 'features/DealerReconciliationReport/screens/DealerReconciliationReportDetailScreen';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import DealerDetailScreen from './screens/DealerDetailScreen';
import DealerListScreen from './screens/DealerListScreen';
import EditAgencyScreen from './screens/EditAgencyScreen';

function ManageDealer(props) {
  const { isSaleInfo } = props;
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0 pb-4">
        <Routes>
          <Route path="" element={<DealerListScreen />} />
          <Route
            path={"/add"}
            element={<EditAgencyScreen agencyRole="SALE" />}
          />
          <Route path="/:agencyId" element={<DealerDetailScreen isSaleInfo={isSaleInfo} />} />
          <Route
            path={"/:agencyId/edit"}
            element={<EditAgencyScreen agencyRole="SALE" />}
          />
          <Route
            path={"/:agencyId/add"}
            element={<EditAgencyScreen agencyRole="SALE" isAddSubAgency={true} />}
          />
          <Route path="/:agencyId/:saleId" element={<AgencySaleDetailScreen />} />
          <Route path="/sale-info/:dealerId" element={<DealerDetailScreen />} />
          <Route path="/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
          <Route path="/:agencyId/add-order" element={<AgencySaleAddOrderScreen removeBaseLayout={true} />} />
          <Route
            path="/:dealerId/detail-order/:orderId"
            element={<DealerReconciliationReportDetailScreen />}
          />
          <Route path="*" element={<>Not found</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ManageDealer;
